// @flow
import api from 'tim-api';
import { distributors as distributorsEndPoint, distributorsAllOrUserToAssociate as distributorsAllOrUserToAssociate } from 'endPoints';

export const state = {
  distributors: [],
  distributorsByUser: [],
  pagination: null,
  ddds: []
};

export const getters = {
  distributors: (state: Object) => state.distributors,
  distributorsByUser: (state: Object) => state.distributorsByUser,
  distributorById: (state: Object) => (id: string) => state.distributors.find((distributors: Object) => distributors.id === id),
  pagination: (state: Object) => state.pagination,
  ddds: (state: Object) => state.ddds
};

export const mutations = {
  SET_DISTRIBUTORS(state: Object, distributors: Array<Object>) {
    state.distributors = distributors;
  },
  SET_DISTRIBUTORS_BY_USER(state: Object, distributorsByUser: Array<Object>) {
    state.distributorsByUser = distributorsByUser;
  },
  SET_PAGINATION(state: Object, pagination: Object) {
    state.pagination = pagination;
  },
  SET_DDDS(state: Object, ddds: Object) {
    state.ddds = ddds || [];
  }
};

export const actions = {
  fetchDistributors({ commit }: Action, { page, search, sort = { order: 'desc', sort: 'name' } }: Object) {
    commit('SET_DISTRIBUTORS', []);

    const url = search ? `distributor/search/?filter=${search}&page=${page || 1}&order=${sort.order || 'desc'}&sort=${sort.sort || 'name'}` : `${distributorsEndPoint}?page=${page || 1}&order=${sort.order || 'desc'}&sort=${sort.sort || 'name'}`;

    return api.get(url).then(({ data }) => {
      commit('SET_DISTRIBUTORS', data.data);
      commit('SET_PAGINATION', {
        current_page: data.current_page,
        first_page_url: data.first_page_url,
        from: data.from,
        last_page: data.last_page,
        last_page_url: data.last_page_url,
        next_page_url: data.next_page_url,
        path: data.path,
        per_page: data.per_page,
        prev_page_url: data.prev_page_url,
        total: data.total
      });
    });
  },

  fetchDistributorBySearch({ commit }: Action, { filter, page = 1, sort }: Object) {
    const url = filter ? `distributor/search/?filter=${filter}&page=${page || 1}&order=${sort.order || 'desc'}&sort=${sort.sort || 'name'}` : `${distributorsEndPoint}?page=${page || 1}&order=${sort.order || 'desc'}&sort=${sort.sort || 'name'}`;

    return api.get(url)
      .then(({ data }) => {
        commit('SET_DISTRIBUTORS', data.data);
        commit('SET_PAGINATION', {
          current_page: data.current_page,
          first_page_url: data.first_page_url,
          from: data.from,
          last_page: data.last_page,
          last_page_url: data.last_page_url,
          next_page_url: data.next_page_url,
          path: data.path,
          per_page: data.per_page,
          prev_page_url: data.prev_page_url,
          total: data.total
        });
      });
  },
  fetchDistributorById({ commit }: Action, id: string) {
    return api.get(`${distributorsEndPoint}/${id}`).then(({ data }) => {
      commit('SET_DISTRIBUTORS', [data.data]);
    });
  },

  fetchAllDistributors({ commit }: Action) {
    return api.get(`${distributorsEndPoint}/all?sort=name&order=asc`).then(({ data }) => {
      commit('SET_DISTRIBUTORS', data);
    });
  },

  fetchAllOrUserToAssociate({ commit }: Action) {
    return api.get(`${distributorsAllOrUserToAssociate}`).then(({ data }) => {
      commit('SET_DISTRIBUTORS_BY_USER', data.data);
    });
  },

  fetchAllDistributorsWithoutChannelFilter({ commit }: Action) {
    return api.get(`${distributorsEndPoint}/all-without-channel-filter?sort=name&order=asc`).then(({ data }) => {
      commit('SET_DISTRIBUTORS', data);
    });
  },

  fetchDDDS({ commit }: Action) {
    return api.get('/ddd').then(({ data }) => {
      commit('SET_DDDS', data.data);
    });
  },

  // eslint-disable-next-line
  update({ commit }: Action, { distributors, id }: Object) {
    return api.put(`${distributorsEndPoint}/${id}`, distributors);
  },

  // eslint-disable-next-line
  create({ commit }: Action, { distributors }: Object) {
    return api.post(`${distributorsEndPoint}`, distributors);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
